export default __webpack_public_path__ + "static/Opened-envelope-icon-095ca2ed0cd1e1915e3cefdff5287890.svg";